import { Vue, Component, Prop } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import CohortSelection from '../../cohort-selection/cohort-selection';
import { cohortAPI } from '@/providers/apis/cohort/cohort';
import { EventBus } from '@/main';

@Component({
    name: 'cohort-access',
    components: {
        'material-icons': GoogleMaterialIcon,
        'cohort-selection': CohortSelection,
    },
})

export default class CohortAccess extends Vue {

    // ----------------------------------------------------------------------------
    // Properties

    @Prop({default: {}})
    private userData: any;

    private showRoles: any = false;

    private isAclAvailable: boolean = false;

    private mounted() {
        this.onCheckACL();
    }
    // -----------------------------------------------------------------------------
    // Actions
    private onSwitchComponent(key: string) {
        this.$emit('onSwitchComponent', key);
    }

    private saveAcl() {
        EventBus.$emit('onSaveAcl');
    }

    private onCheckACL() {
        const that = this;
        EventBus.$on('onCheckAcl', (list: any) => {
            that.isAclAvailable = list && list.length > 0 ? true : false;
        });
    }

}
